import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const IBInformationRequest = {
  information: async (email) => {
    const cookies = new Cookies();
    const token = cookies.get("token");

    return AxiosInstance.get("/information", {
      params: { email },
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default IBInformationRequest;